import type { JSX } from "react";
import type { ExportChartFormats } from "../../viewer/chart/ChartProps.ts";
import ExcelTableIcon from "@entrilia/shared/icons/ExcelTableIcon";
import ExportImageIcon from "@entrilia/shared/icons/ExportImageIcon";
import ExportPdfIcon from "@entrilia/shared/icons/ExportPdfIcon";
import ExportSvgIcon from "@entrilia/shared/icons/ExportSvgIcon";

export type ExportOption = {
  key: string;
  title: string;
  Icon: JSX.Element;
  onClick: () => void;
};

export const excelExportOptions = [
  { key: "withoutParameters", title: "Excel", Icon: <ExcelTableIcon />, withParameters: false },
  { key: "withParameters", title: "Excel including Parameters", Icon: <ExcelTableIcon />, withParameters: true },
];

export const exportFormats: { icon: JSX.Element; ext: ExportChartFormats }[] = [
  { icon: <ExportPdfIcon />, ext: "PDF" },
  { icon: <ExportImageIcon />, ext: "PNG" },
  { icon: <ExportImageIcon />, ext: "JPEG" },
  { icon: <ExportSvgIcon />, ext: "SVG" },
];
